import HTTP from './HTTP.js';
import SymfonyErrorFormatter from './SymfonyErrorFormatter';

class FileServices {
    static uploadTempFile(formData) {
		return HTTP.post(`files/temporary`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((response) => {
            return response.data;
        }).catch(error => {
            return SymfonyErrorFormatter.clean(error.response);
        });
    }

    static uploadMultipleTempFiles(formData) {
        return HTTP.post(`files/multiple/temporary`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((response) => {
            return response.data;
        }).catch(error => {
            return SymfonyErrorFormatter.clean(error.response);
        });
    }

    static uploadFile(formData) {
        return HTTP.post('files', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((response) => {
            return response.data;
        }).catch(error => {
            return SymfonyErrorFormatter.clean(error.response);
        });
    }
}

export default FileServices;